import type { ArtTransform } from "../schedule-art/art-transform";
import type { CommonOptions, Profile, StreamSlot } from "../schedule-document/schedule-values";
import type { ScheduleDocument } from "../schedule-document/schedule-json";

export type ScheduleEventPayload =
  | { type: "slot/set"; key: string; patch: Partial<StreamSlot> }
  | { type: "slot/reset"; key: string }
  | { type: "slot/swap"; sourceKey: string; targetKey: string }
  | { type: "offline/set"; dateKey: string; patch: { message?: string; active?: boolean } }
  | { type: "offline/swap"; sourceDate: string; targetDate: string }
  | { type: "date/set"; date: string }
  | { type: "timezone/set"; timezone: string }
  | { type: "preset/select"; presetId: string }
  | { type: "document/load"; document: ScheduleDocument }
  | { type: "document/reset" }
  | { type: "common/set"; patch: Partial<CommonOptions> }
  | { type: "profile/set"; patch: Partial<Profile> }
  | { type: "handle/setPosition"; position: number[] }
  | { type: "handle/setScale"; scale: number }
  | { type: "handle/setRotation"; rotation: number }
  | { type: "art/addImages"; images: { imageId: string; name: string }[] }
  | { type: "art/setTransform"; imageId: string; transform: ArtTransform }
  | { type: "art/setVisibility"; imageId: string; visible: boolean }
  | { type: "art/remove"; imageId: string }
  | { type: "art/reorder"; imageIds: string[] };

export type ScheduleEventType = ScheduleEventPayload["type"];

export type ScheduleEvent = ScheduleEventPayload & {
  id: string;
  at: number;
  mergeKey?: string;
};

export function createEvent(payload: ScheduleEventPayload, mergeKey?: string): ScheduleEvent {
  return { ...payload, id: crypto.randomUUID(), at: Date.now(), mergeKey };
}
